/* 
Used by LiveBlogEntries to make sure that any markup that happens to be in an entry
gets rendered correctly despite being inside a preact component

this makes tweet embeds, youtube embeds, basically anything with a <script> tag work
*/
import { Component } from "preact";
import { uniq, slice } from "tpm-utils";

export default class RawMarkup extends Component {
	normalize(content = this.props.content) {
		return RawMarkup.normalize(content, (dom) => {
			slice(dom.getElementsByTagName("script")).forEach((script) => {
				if (typeof script.remove === "function") {
					script.remove();
				} else {
					script.parentNode.removeChild(script);
				}
				this.enqueueScript(script);
			});

			slice(dom.getElementsByTagName("iframe")).forEach((frame) => {
				const container = dom.createElement("div");
				container.className = "iframe-container";
				frame.parentElement.insertBefore(container, frame);
				container.appendChild(frame);
			});
		});
	}

	render({ content, ...props }) {
		return (
			<div {...props}>
				<div dangerouslySetInnerHTML={{ __html: this.normalize(content) }} />
			</div>
		);
	}
	componentDidMount() {
		RawMarkup.processScriptQueue();
	}

	componentDidUpdate() {
		RawMarkup.processScriptQueue();
	}

	enqueueScript(script) {
		RawMarkup.scriptQueue.push(script);
	}

	static scriptCache = {};
	static scriptQueue = [];
	static callbackQueue = [];

	static processScriptQueue() {
		const scriptPromises = uniq(RawMarkup.scriptQueue).map((script) => {
			const unloaded = document.createElement("script");

			for (let idx = 0; idx < script.attributes.length; idx++) {
				unloaded[script.attributes[idx].name] = script.attributes[idx].value;
			}

			const scriptPromise = new Promise((r) => {
				unloaded.onload = () => {
					r(unloaded);
				};
			});

			document.head.appendChild(unloaded);

			return scriptPromise;
		});

		RawMarkup.scriptQueue.length = 0;

		const callbacks = RawMarkup.callbackQueue.splice(0);
		RawMarkup.callbackQueue.length = 0;

		Promise.all(scriptPromises).then((scripts) => {
			callbacks.forEach((fn) => fn(scripts));
		});
	}

	static onProcessScriptQueue(callback) {
		RawMarkup.callbackQueue.push(callback);
	}

	static normalize(input, filter) {
		if (!input) return input;

		const parser = new window.DOMParser();

		const dom = parser.parseFromString(input, "text/html");

		if (filter) filter(dom);

		return dom.body.innerHTML;
	}
}
